import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Dispatch, SetStateAction, useState } from "react";
import { useLazyLoadQuery, useMutation } from "react-relay";
import styled from "styled-components";
import { multipleChoiceAnswersDropdowns_Query } from "@generated/multipleChoiceAnswersDropdowns_Query.graphql";
import { multipleChoiceAnswersDropdowns_SubmitMultipleChoiceElementMutation } from "@generated/multipleChoiceAnswersDropdowns_SubmitMultipleChoiceElementMutation.graphql";
import { QUERY, SUBMIT_MUTATION } from "./multiple-choice-answers-dropdowns.graphql";
import { StripHtml } from "../../../../infecto-lms-webapp/functions/helpers/StripHtml";

interface OwnProps {
	elementId: string;
	contentSubmissionId: string;
	checkedAnswers: readonly number[];
	isLastQuestion: boolean;
	setLastAnswerCheckedAnswerIndices: (indices: number[]) => void;
	editingIndexArray: number[];
	setEditingIndexArray: Dispatch<SetStateAction<number[]>>;
	questionIndex: number;
	reloadSubmittedAnswersQuery: () => void;
}

export const MultipleChoiceAnswersDropdownsComponent = ({
	elementId,
	contentSubmissionId,
	checkedAnswers,
	isLastQuestion,
	setLastAnswerCheckedAnswerIndices,
	setEditingIndexArray,
	editingIndexArray,
	questionIndex,
	reloadSubmittedAnswersQuery,
}: OwnProps) => {
	const elementData = useLazyLoadQuery<multipleChoiceAnswersDropdowns_Query>(QUERY, {
		elementId: elementId,
	});
	const answerType = elementData.LearnV2.GetLearnElement.answeringType;
	const [submitElement] =
		useMutation<multipleChoiceAnswersDropdowns_SubmitMultipleChoiceElementMutation>(
			SUBMIT_MUTATION,
		);
	const [selectedAnswerIndices, setSelectedAnswerIndices] = useState<number[]>([...checkedAnswers]);

	const options = elementData.LearnV2.GetLearnElement.answerOptions.map((option, index) => ({
		label: ` ${StripHtml(option.answer)}`,
		value: index,
	}));
	const handleValue = () => {
		if (isLastQuestion) {
			return checkedAnswers.length > 0 ? checkedAnswers[0] : null;
		} else {
			return selectedAnswerIndices.length > 0 ? selectedAnswerIndices[0] : null;
		}
	};
	//eslint-disable-next-line @typescript-eslint/no-explicit-any
	const itemTemplate = (value: any) => {
		return (
			<div
				style={{
					whiteSpace: "normal",
					overflowWrap: "break-word",
					wordWrap: "break-word",
				}}
			>
				{value.label}
			</div>
		);
	};
	const removeQuestionFromArray = (questionIndex: number) => {
		setTimeout(
			() => setEditingIndexArray(editingIndexArray.filter((i) => i !== questionIndex)),
			2000,
		);
	};
	return (
		<Container>
			{answerType === "allowOnlyOneAnswer" ? (
				<Container>
					<StyledDropdown
						value={handleValue()}
						options={options}
						onChange={(e) => {
							if (isLastQuestion) {
								setLastAnswerCheckedAnswerIndices([e.value]);
								removeQuestionFromArray(questionIndex);
							} else {
								setSelectedAnswerIndices([e.value]);
								submitElement({
									variables: {
										input: {
											multipleChoiceElementId: elementId,
											contentSubmissionId,
											checkedAnswerIndices: [e.value],
										},
									},
									onCompleted() {
										setEditingIndexArray(editingIndexArray.filter((i) => i !== questionIndex));
										reloadSubmittedAnswersQuery();
									},
								});
							}
						}}
					/>
				</Container>
			) : (
				<Container>
					<StyledMultiselect
						style={{ width: "100%" }}
						value={isLastQuestion ? checkedAnswers : selectedAnswerIndices}
						panelStyle={
							window.innerWidth < 480
								? { minWidth: "250px", maxWidth: "300px", top: "-230px" }
								: { minWidth: "250px", maxWidth: "400px" }
						}
						options={options}
						itemTemplate={itemTemplate}
						onChange={(e) => {
							if (isLastQuestion) {
								setLastAnswerCheckedAnswerIndices(e.value);
								removeQuestionFromArray(questionIndex);
							} else {
								setSelectedAnswerIndices(e.value);
								submitElement({
									variables: {
										input: {
											multipleChoiceElementId: elementId,
											contentSubmissionId,
											checkedAnswerIndices: e.value,
										},
									},
									onCompleted() {
										removeQuestionFromArray(questionIndex);
										reloadSubmittedAnswersQuery();
									},
								});
							}
						}}
					/>
				</Container>
			)}
		</Container>
	);
};

const StyledDropdown = styled(Dropdown)`
	.p-inputtext {
		font-size: 12px;
	}
	.p-dropdown-items {
		max-width: 100%;
	}
	.p-dropdown-item {
		font-size: 10px;
		white-space: normal !important;
	}
	@media screen and (max-width: 768px) {
		.p-inputtext,
		.p-dropdown-item {
			font-size: 10px;
			white-space: normal !important;
		}

		@media screen and (max-width: 768px) and (min-width: 480px) {
			.p-multiselect-label {
				font-size: 12px !important;
				white-space: normal !important;
			}
		}
	}
`;
const StyledMultiselect = styled(MultiSelect)`
	.p-multiselect-label {
		font-size: 14px;
	}
	.p-multiselect-label {
		font-size: 12px !important;
		white-space: normal !important;
	}
	@media screen and (max-width: 480px) {
		.p-multiselect-label {
			font-size: 10px !important;
			white-space: normal !important;
		}
	}
`;

const Container = styled.div`
	width: 100%;
	margin-left: 5px;
`;
